import { Component } from 'react';
import styled from 'styled-components';

import { fontSize } from '../../../../../common/css/setting/variable';
import { toTopicsListLink, WebCategory } from '../../../../../../../domain/model/category/WebCategory';

const Link = styled.a`
  display: block;
  padding: 8px 0;
  font-size: ${fontSize.px14};
  font-weight: bold;
`;

const Text = styled.p`
  /* トピックス一覧64本ページでは「もっと見る」ボタンしかなく、表示を調整するため */
  &:only-child {
    margin-left: auto;

    ${Link} {
      font-weight: normal;
    }
  }
`;

interface IProps {
  dataClParams: string;
  category?: WebCategory;
}
export default class TopicsListReadMoreLink extends Component<IProps> {
  /**
   *
   */
  public render() {
    const linkUrl = this.props.category ? toTopicsListLink(this.props.category) : undefined;
    if (linkUrl) {
      return (
        <Text>
          <Link href={linkUrl} data-cl-params={this.props.dataClParams}>
            もっと見る
          </Link>
        </Text>
      );
    }
    return null;
  }
}
